import { useTranslation } from "react-i18next";

import ActionPanelFrame, { ReturnActionPanelProps } from "./ActionPanelFrame";

/** Decline – eBay only offers it on a change-of-mind return against a no-returns policy. */
export default function DeclinePanel({ detail, onConfirm, onCancel, busy }: ReturnActionPanelProps) {
  const { t } = useTranslation("returns");
  return (
    <ActionPanelFrame kind="decline" detail={detail} confirmLabel={t("Confirm decline – send to eBay")} onConfirm={(message) => onConfirm({ message })} onCancel={onCancel} busy={busy}>
      <div className="rounded-lg border border-red-200 bg-red-50 px-3 py-2.5 text-[12px] text-red-900">
        <span className="font-semibold">{t("Decline is available")}</span>{" "}
        {t('because the listing\'s eBay policy is "No returns" and the reason is a change of mind.')}{" "}
        {t("The buyer can still ask eBay to step in within 3 business days, so say why in the message.")}
      </div>
    </ActionPanelFrame>
  );
}
